export default __webpack_public_path__ + "static/Entenda0083-630db1e5f4b6bfb5a76cee46551a7d1c.jpg";